import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { PANDA_I18N_CACHED } from "../const";
window[PANDA_I18N_CACHED] = _extends({
  PACKID_LIST: [],
  INDEX: 0,
  KEY_MAP: {},
  VK_MAP: new Map()
}, window[PANDA_I18N_CACHED]);
var NUM_HIDDEN = {
  '#': "\u206F",
  '1': "\u202A",
  '2': "\u200E",
  '3': "\u2066",
  '4': "\u2068",
  '5': "\u2061",
  '6': "\u2062",
  '7': "\u2063",
  '8': "\u2064",
  '9': "\u2065",
  '0': "\u206E"
};
var NUM_SHOWED = {
  "\u206F": '#',
  "\u202A": '1',
  "\u200E": '2',
  "\u2066": '3',
  "\u2068": '4',
  "\u2061": '5',
  "\u2062": '6',
  "\u2063": '7',
  "\u2064": '8',
  "\u2065": '9',
  "\u206E": '0'
};
var HIDDEN_REG = /[\u206F\u202A\u200E\u2066\u2068\u2061\u2062\u2063\u2064\u2065\u206E]/g;
function serialize(obj) {
  var fkv = {};
  var fkvs = [];
  ['copyKey', 'packId', 'type', 'componentName', 'isMatched', 'packageName'].forEach(function (key) {
    if (obj[key]) {
      fkv[key] = obj[key];
      fkvs.push(key + ":" + obj[key].toString());
    }
  });
  return [fkv, fkvs.join(';')];
}

/** 将信息转换成mapping index */
function set(VK) {
  var index;
  var _serialize = serialize(VK),
    fvk = _serialize[0],
    fkvkey = _serialize[1];
  if (!window[PANDA_I18N_CACHED].VK_MAP.has(fkvkey)) {
    index = ++window[PANDA_I18N_CACHED].INDEX;
    window[PANDA_I18N_CACHED].VK_MAP.set(fkvkey, index);
    window[PANDA_I18N_CACHED].KEY_MAP[index] = fvk;
  } else {
    index = window[PANDA_I18N_CACHED].VK_MAP.get(fkvkey);
  }
  return decode(index);
}

/** 根据index的获取mapping信息 */
function get(index) {
  var _window$PANDA_I18N_CA;
  return ((_window$PANDA_I18N_CA = window[PANDA_I18N_CACHED].KEY_MAP) === null || _window$PANDA_I18N_CA === void 0 ? void 0 : _window$PANDA_I18N_CA[index]) || null;
}

/** 将index转成不可见字符 */
function decode(index) {
  return index.toString().split('').map(function (num) {
    return NUM_HIDDEN[num];
  }).join('');
}

/** 将不可见字符转成index */
function encode(str) {
  return str.split('').map(function (cur) {
    return NUM_HIDDEN[cur];
  }).join('');
}

/** 将字符串和信息混入索引和不可见字符 */
function encrypt(str, VK) {
  return "\u206F\u206F" + str + "\u206F\u206F" + set(VK) + "\u206F\u206F";
}

/** 将混有不可见字符的字符串反向解密返回原始字符串和信息 */
function decrypt(str) {
  if (str.includes("\u206F\u206F")) {
    var spts = str.split("\u206F\u206F");
    return {
      copy: str.replace(HIDDEN_REG, ''),
      info: spts.length >= 4 ? get(spts[2].split('').map(function (item) {
        return NUM_SHOWED[item];
      }).join('')) : null
    };
  }
  return {
    copy: str,
    info: null
  };
}

/** 将混有不可见字符的字符串反向解密返回原始字符串 */
function getOriginalCopy(str) {
  return str.includes("\u206F") ? str.replace(HIDDEN_REG, '') : str;
}
export var i18nMapping = {
  set: set,
  get: get,
  decode: decode,
  encode: encode,
  encrypt: encrypt,
  decrypt: decrypt,
  getOriginalCopy: getOriginalCopy
};